const datetime = {
    now() {
        return Date.now() || new Date().getTime();
    },
}

export const throttle = (func, wait = 300) => {
    let previous = 0,
        timeout,
        args;

    const later = (context) => {
        previous = datetime.now();
        timeout = null;
        func.apply(context, args);
        args = null;
    };

    return function(...rest) {
        const now = datetime.now(),
            remaining = wait - (now - previous);

        args = rest;

        if (remaining <= 0 || remaining > wait) {
            previous = now;
            func.apply(this, args);

            clearTimeout(timeout);
            timeout = null;
            args = null;
        } else if (!timeout) {
            timeout = setTimeout(() => {
                later(this);
            }, remaining);
        } else {
            // Do Not Anything
        }
    };
};
